var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrassRoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76069 13.1607C8.76069 13.1607 16.5759 3.61231 13.5602 1.11658C10.6818 -1.26598 5.20536 11.1123 5.20536 11.1123C5.20536 11.1123 5.54957 3.49174 1.93026 2.59045C-1.68905 1.68984 1.24653 13.3877 1.24653 13.3877L8.76069 13.1607Z",
    fill: "#6B5E17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrassRoot);
export default __webpack_public_path__ + "static/media/grassRoot.92d78a1defdd715514cbfcfa1808d8ff.svg";
export { ForwardRef as ReactComponent };